import useCareerApi from "../../api/career/careerApi";
import CareerModal from "../CareerModal";
import Styles from "./styles.module.scss";
import { useState } from "react";

const ResponsibilitiesSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M9.88664 18.8764L13.317 22.3068C13.5858 22.5756 13.9378 22.71 14.2866 22.71C14.6386 22.71 14.9874 22.5756 15.2562 22.3068L22.117 15.446C22.6546 14.9084 22.6546 14.0412 22.117 13.5036C21.5826 12.966 20.7122 12.966 20.1778 13.5036L14.2866 19.398L11.8258 16.9372C11.2914 16.4028 10.421 16.4028 9.88344 16.9372C9.35224 17.4716 9.35224 18.342 9.88664 18.8764ZM28.3666 2.53081H22.3634C22.5842 2.84761 22.7122 3.22841 22.7122 3.64441C22.7122 4.05721 22.5842 4.44121 22.3634 4.75801H27.253V29.4556H4.74744V4.75801H9.60504C9.38424 4.44121 9.25624 4.06041 9.25624 3.64441C9.25624 3.23161 9.38424 2.84761 9.60504 2.53081H3.63704C3.02264 2.53081 2.52344 3.03001 2.52344 3.64441V30.566C2.52344 31.1804 3.02264 31.6796 3.63704 31.6796H28.3666C28.981 31.6796 29.4802 31.1804 29.4802 30.566V3.64441C29.4802 3.03001 28.981 2.53081 28.3666 2.53081ZM13.6466 7.03001H18.2738C19.4642 7.03001 20.4274 6.06681 20.4274 4.87641V4.68441C20.4274 3.49401 19.4642 2.53081 18.2738 2.53081H18.1842C18.2578 2.34521 18.2994 2.14361 18.2994 1.93241C18.2994 1.03961 17.5762 0.316406 16.6834 0.316406H15.3202C14.4274 0.316406 13.7042 1.03961 13.7042 1.93241C13.7042 2.14361 13.7458 2.34521 13.8194 2.53081H13.6434C12.453 2.53081 11.4898 3.49401 11.4898 4.68441V4.87641C11.493 6.06681 12.4594 7.03001 13.6466 7.03001Z"
      fill="#1E1E1E"
    />
  </svg>
);

const RequirementsSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.72431 5.78571C6.47737 5.78571 6.24055 5.88355 6.06594 6.05769C5.89133 6.23183 5.79323 6.46801 5.79323 6.71429V25.2857C5.79323 25.532 5.89133 25.7682 6.06594 25.9423C6.24055 26.1165 6.47737 26.2143 6.72431 26.2143H16.5006C16.871 26.2143 17.2263 26.361 17.4882 26.6222C17.7501 26.8835 17.8972 27.2377 17.8972 27.6071C17.8972 27.9766 17.7501 28.3308 17.4882 28.592C17.2263 28.8533 16.871 29 16.5006 29H6.72431C5.73656 29 4.78927 28.6087 4.09082 27.9121C3.39238 27.2155 3 26.2708 3 25.2857V6.71429C3 5.7292 3.39238 4.78445 4.09082 4.08789C4.78927 3.39133 5.73656 3 6.72431 3H25.3458C26.3336 3 27.2809 3.39133 27.9793 4.08789C28.6778 4.78445 29.0702 5.7292 29.0702 6.71429V18.3214C29.0702 18.6908 28.923 19.0451 28.6611 19.3063C28.3992 19.5675 28.0439 19.7143 27.6735 19.7143C27.3031 19.7143 26.9479 19.5675 26.686 19.3063C26.4241 19.0451 26.2769 18.6908 26.2769 18.3214V6.71429C26.2769 6.46801 26.1788 6.23183 26.0042 6.05769C25.8296 5.88355 25.5928 5.78571 25.3458 5.78571H6.72431ZM29.5916 21.98C29.8531 22.2412 30 22.5952 30 22.9643C30 23.3334 29.8531 23.6874 29.5916 23.9486L24.9362 28.5914C24.6743 28.8523 24.3193 28.9988 23.9492 28.9988C23.5791 28.9988 23.2242 28.8523 22.9623 28.5914L21.1001 26.7343C20.9629 26.6068 20.8529 26.453 20.7765 26.2821C20.7002 26.1113 20.6591 25.9268 20.6558 25.7398C20.6525 25.5528 20.687 25.367 20.7573 25.1936C20.8275 25.0202 20.9321 24.8626 21.0647 24.7304C21.1973 24.5981 21.3553 24.4938 21.5292 24.4238C21.7031 24.3537 21.8894 24.3193 22.0769 24.3226C22.2644 24.3259 22.4493 24.3668 22.6207 24.443C22.792 24.5191 22.9462 24.6289 23.074 24.7657L23.9492 25.6386L27.6177 21.98C27.8795 21.7192 28.2345 21.5727 28.6046 21.5727C28.9747 21.5727 29.3297 21.7192 29.5916 21.98ZM9.98308 8.57143C9.61267 8.57143 9.25744 8.71818 8.99552 8.97939C8.7336 9.2406 8.58646 9.59488 8.58646 9.96429C8.58646 10.3337 8.7336 10.688 8.99552 10.9492C9.25744 11.2104 9.61267 11.3571 9.98308 11.3571H22.0871C22.4575 11.3571 22.8127 11.2104 23.0746 10.9492C23.3365 10.688 23.4837 10.3337 23.4837 9.96429C23.4837 9.59488 23.3365 9.2406 23.0746 8.97939C22.8127 8.71818 22.4575 8.57143 22.0871 8.57143H9.98308ZM8.58646 16C8.58646 15.6306 8.7336 15.2763 8.99552 15.0151C9.25744 14.7539 9.61267 14.6071 9.98308 14.6071H22.0871C22.4575 14.6071 22.8127 14.7539 23.0746 15.0151C23.3365 15.2763 23.4837 15.6306 23.4837 16C23.4837 16.3694 23.3365 16.7237 23.0746 16.9849C22.8127 17.2461 22.4575 17.3929 22.0871 17.3929H9.98308C9.61267 17.3929 9.25744 17.2461 8.99552 16.9849C8.7336 16.7237 8.58646 16.3694 8.58646 16ZM9.98308 20.6429C9.61267 20.6429 9.25744 20.7896 8.99552 21.0508C8.7336 21.312 8.58646 21.6663 8.58646 22.0357C8.58646 22.4051 8.7336 22.7594 8.99552 23.0206C9.25744 23.2818 9.61267 23.4286 9.98308 23.4286H16.5006C16.871 23.4286 17.2263 23.2818 17.4882 23.0206C17.7501 22.7594 17.8972 22.4051 17.8972 22.0357C17.8972 21.6663 17.7501 21.312 17.4882 21.0508C17.2263 20.7896 16.871 20.6429 16.5006 20.6429H9.98308Z"
      fill="black"
    />
  </svg>
);

const PlusSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M28.2235 3.80078C26.6751 2.24479 24.4885 2 21.9067 2H10.0628C7.51215 2 5.32556 2.24414 3.77648 3.80078C2.22805 5.35677 2 7.53906 2 10.0872V21.8672C2 24.4766 2.22741 26.6432 3.77648 28.1992C5.32491 29.7552 7.51215 30 10.1082 30H21.9067C24.4885 30 26.6751 29.7559 28.2235 28.1992C29.7726 26.6432 30 24.4766 30 21.8672V10.1328C30 7.52344 29.7726 5.34115 28.2235 3.80078ZM27.5556 9.70573V22.2793C27.5556 23.8659 27.358 25.4831 26.4477 26.4141C25.5212 27.3294 23.8808 27.543 22.3168 27.543H9.68319C8.11921 27.543 6.47943 27.3294 5.56851 26.4141C4.64205 25.4831 4.44444 23.8659 4.44444 22.2786V9.75195C4.44444 8.15039 4.64205 6.50195 5.55296 5.58659C6.47943 4.6556 8.13411 4.45768 9.72854 4.45768H22.3168C23.8808 4.45768 25.5206 4.67122 26.447 5.58659C27.358 6.51758 27.5556 8.13411 27.5556 9.70573ZM16 24.1406C16.6077 24.1406 17.0936 23.6673 17.0936 23.0573V17.0911H23.0308C23.6378 17.0911 24.1237 16.5723 24.1237 16.0078C24.1237 15.4128 23.6378 14.9089 23.0308 14.9089H17.0936V8.92773C17.0936 8.31706 16.6077 7.8444 16 7.8444C15.8578 7.84229 15.7167 7.86888 15.585 7.92257C15.4532 7.97627 15.3335 8.05599 15.233 8.15701C15.1325 8.25803 15.0532 8.37829 14.9997 8.51068C14.9463 8.64307 14.9198 8.78489 14.9219 8.92773V14.9089H8.98478C8.37707 14.9089 7.89116 15.4128 7.89116 16.0078C7.89116 16.5723 8.37707 17.0911 8.98478 17.0911H14.9219V23.0573C14.9219 23.6673 15.3929 24.1406 16 24.1406Z"
      fill="black"
    />
  </svg>
);

const OfferSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M5.33333 16H4V10.6667C4 9.19391 5.19391 8 6.66667 8H12M5.33333 16V24C5.33333 25.4728 6.52724 26.6667 8 26.6667H24C25.4728 26.6667 26.6667 25.4728 26.6667 24V16M5.33333 16H13.3333M12 8V6.66667C12 5.19391 13.1939 4 14.6667 4H17.3333C18.8061 4 20 5.19391 20 6.66667V8M12 8H20M26.6667 16H28V10.6667C28 9.19391 26.8061 8 25.3333 8H20M26.6667 16H18.6667M13.3333 16V13.3333H18.6667V16M13.3333 16V18.6667H18.6667V16"
      stroke="black"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const handleSvg = (title) => {
  switch (title) {
    case "responsibilities":
      return <ResponsibilitiesSvg />;

    case "requirements":
      return <RequirementsSvg />;

    case "plus":
      return <PlusSvg />;

    case "offer":
      return <OfferSvg />;
  }
};

const handleTitle = (title) => {
  switch (title) {
    case "responsibilities":
      return "Functional responsibilities";
    case "requirements":
      return "Requirements";
    case "plus":
      return "Would be a plus";
    case "offer":
      return "What we offer";
  }
};

const BlockParagraph = ({ isResponsibilities, textElements }) => {
  console.log("textElements", textElements);
  if (isResponsibilities) {
    return (
      <div
        className={`${Styles.block_li_wrapper} ${Styles.responsibilities_wrapper}`}
      >
        <span>{textElements}</span>
      </div>
    );
  }

  return (
    <ul className={Styles.block_li_wrapper}>
      {textElements.map((text, index) => {
        return (
          <li key={index}>
            <div className={Styles.dot} /> <span>{text}</span>
          </li>
        );
      })}
    </ul>
  );
};

const CareerBlock = ({ text, title }) => {
  console.log("text", text);
  const isResponsibilities = title === "responsibilities";

  return (
    <div className={Styles.block_wrapper}>
      <div className={Styles.title_wrapper_small}>
        <div>{handleSvg(title)}</div>
        <div>
          <span className={Styles.shadow_title_small}>
            {handleTitle(title)}
          </span>
          <h2 className={Styles.title_sub}>{handleTitle(title)}</h2>
        </div>
      </div>
      <BlockParagraph
        isResponsibilities={isResponsibilities}
        textElements={text}
      />
    </div>
  );
};

const TEXT_ELEMENTS = [
  {
    title: "responsibilities",
    textElements: [
      "We are looking for a web developer to join our team. The ideal candidate will have experience in web development and be able to work in a fast-paced environment.",
    ],
  },
  {
    title: "requirements",
    textElements: [
      "Experience with HTML, CSS, JavaScript, and jQuery",
      "Experience with PHP and MySQL",
      "Experience with WordPress",
      "Experience with responsive and adaptive design",
      "Understanding of SEO principles",
      "Good problem-solving skills",
      "Excellent verbal and written communication skills",
      "Ability to work in a team environment",
      "Ability to work in a fast-paced environment",
    ],
  },
  {
    title: "plus",
    textElements: [
      "Experience with React",
      "Experience with Node.js",
      "Experience with MongoDB",
      "Experience with AWS",
      "Experience with Docker",
      "Experience with Git",
      "Experience with Agile methodologies",
    ],
  },
  {
    title: "offer",
    textElements: [
      "Competitive salary",
      "Flexible hours",
      "Remote work",
      "Health insurance",
      "Paid time off",
      "Professional development",
      "Opportunities for advancement",
    ],
  },
];
const JoinUsDesc = ({ id }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const onClose = () => {
    setIsModalOpen(false);
  };
  const onOpen = () => {
    setIsModalOpen(true);
  };

  const { data, status } = useCareerApi("single", id);
  console.log(data);
  if (status === "loading") {
    return (
      <div
        style={{
          height: "64.4vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          justifySelf: "center",
        }}
      >
        <div className={Styles.loader}></div>
      </div>
    );
  }
  if (status === "success") {
    console.log("req", data.attributes.requirements);
    return (
      <div className={Styles.container}>
        {/* <span className={Styles.shadow_title} /> */}
        <span className={Styles.block_background} />
        <div className={Styles.title_wrapper}>
          <span className={Styles.shadow_title}>{data.attributes.title}</span>
          <h1 className={Styles.title_main}>{data.attributes.title}</h1>
        </div>
        <div className={Styles.wrapper}>
          <CareerBlock
            title="responsibilities"
            text={data.attributes.responsibilities}
          />
          <CareerBlock
            title="requirements"
            text={data.attributes.requirements}
          />
          <CareerBlock title="plus" text={data.attributes.plus} />
          <CareerBlock title="offer" text={data.attributes.offer} />
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <button onClick={onOpen} className={Styles.career_apply}>
              <span className={Styles.apply_text}>{"Apply now"}</span>
            </button>
          </div>
        </div>
        <CareerModal onClose={onClose} isModalOpen={isModalOpen} />
      </div>
    );
  } else {
    return <div className={Styles.error}>404 Error</div>;
  }
};

export default JoinUsDesc;
